import React, { useState, useEffect } from 'react';
import './EventBookingModal.css';

const EventBookingModal = ({ isOpen, onClose, eventTitle }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        seats: '1',
        message: ''
    });

    // Prevent background scrolling when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        
        // Cleanup on unmount
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    const changeHandler = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const submitHandler = (e) => {
        e.preventDefault();
        // Send email to info@marsheventsandtraininghub.com
        const mailtoLink = `mailto:info@marsheventsandtraininghub.com?subject=${encodeURIComponent(`Event Booking Request - ${eventTitle}`)}&body=${encodeURIComponent(
            `Event: ${eventTitle}\n\nName: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\nNumber of Seats: ${formData.seats}\n\nAdditional Message:\n${formData.message || 'No additional message'}`
        )}`;
        window.location.href = mailtoLink;
        // Reset form
        setFormData({
            name: '',
            email: '',
            phone: '',
            seats: '1',
            message: ''
        });
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="event-booking-modal-overlay" onClick={onClose}>
            <div className="event-booking-modal" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close-btn" onClick={onClose}>
                    <i className="ti-close"></i>
                </button>
                <div className="modal-header">
                    <h2>Book Your Seat</h2>
                    <p className="event-title">{eventTitle}</p>
                </div>
                <form onSubmit={submitHandler} className="booking-form">
                    <div className="form-row">
                        <div className="form-group">
                            <label>Full Name *</label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={changeHandler}
                                placeholder="Enter your full name"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Email Address *</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={changeHandler}
                                placeholder="Enter your email"
                                required
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label>Phone Number *</label>
                            <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={changeHandler}
                                placeholder="Enter your phone number"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Number of Seats *</label>
                            <select
                                name="seats"
                                value={formData.seats}
                                onChange={changeHandler}
                                required
                            >
                                <option value="1">1 Seat</option>
                                <option value="2">2 Seats</option>
                                <option value="3">3 Seats</option>
                                <option value="4">4 Seats</option>
                                <option value="5">5 Seats</option>
                                <option value="6+">6+ Seats</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Additional Message (Optional)</label>
                        <textarea
                            name="message"
                            value={formData.message}
                            onChange={changeHandler}
                            placeholder="Any special requirements or questions?"
                            rows="4"
                        ></textarea>
                    </div>
                    <div className="form-actions">
                        <button type="button" className="btn-cancel" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="btn-submit">
                            Confirm Booking
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EventBookingModal;

